"use client";

import { useEffect, useRef, useState } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export function ApiEndpoint({
  method,
  server,
  path,
}: {
  method: string;
  server: string;
  path: string;
}) {
  const [status, setStatus] = useState<"ready" | "copied" | "error">("ready");
  const [open, setOpen] = useState(false);
  const reset = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(
    () => () => {
      if (reset.current) clearTimeout(reset.current);
    },
    [],
  );
  const endpoint = server.replace(/\/$/, "") + path;
  const message =
    status === "copied"
      ? "Copied endpoint"
      : status === "error"
        ? "Couldn’t copy endpoint"
        : "Copy endpoint";
  async function copy() {
    try {
      await navigator.clipboard.writeText(endpoint);
      setStatus("copied");
    } catch {
      setStatus("error");
    }
    setOpen(true);
    if (reset.current) clearTimeout(reset.current);
    reset.current = setTimeout(() => setStatus("ready"), 1800);
  }
  return (
    <div className="api-endpoint">
      <span className={`api-method api-method-${method.toLowerCase()}`}>
        {method}
      </span>
      <TooltipProvider delayDuration={200}>
        <Tooltip open={open} onOpenChange={setOpen}>
          <TooltipTrigger asChild>
            <button
              type="button"
              className="api-endpoint-copy"
              onClick={copy}
              aria-label={`Copy endpoint ${endpoint}`}
            >
              <code>
                {server.replace(/\/$/, "")}
                <strong>{path}</strong>
              </code>
            </button>
          </TooltipTrigger>
          <TooltipContent
            side="top"
            className={
              status === "copied"
                ? "text-green-700 dark:text-green-400"
                : "text-primary"
            }
          >
            {message}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <span className="sr-only" role="status">
        {status === "ready" ? "" : message}
      </span>
    </div>
  );
}
